/* Eén ingang naar de server: POST /api/x met { actie, ... }. */

const APPARAAT = 'tp-apparaat'

export function apparaatToken(): string | null {
  try { return localStorage.getItem(APPARAAT) } catch { return null }
}

export function zetApparaat(t: string | null) {
  try {
    if (t) localStorage.setItem(APPARAAT, t)
    else localStorage.removeItem(APPARAAT)
  } catch { /* privévenster: dan blijft de tablet niet gekoppeld */ }
}

export class ApiFout extends Error {
  constructor(bericht: string, public status: number, public code: string) {
    super(bericht)
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function vraag<T = any>(actie: string, lijf: Record<string, unknown> = {}): Promise<T> {
  const kop: Record<string, string> = { 'Content-Type': 'application/json' }
  const a = apparaatToken()
  if (a) kop['X-Apparaat'] = a
  let r: Response
  try {
    r = await fetch('/api/x', { method: 'POST', headers: kop, body: JSON.stringify({ ...lijf, actie }), credentials: 'same-origin' })
  } catch {
    throw new ApiFout('Geen verbinding. Kijk of er internet is en probeer het opnieuw.', 0, 'netwerk')
  }
  let d: Record<string, unknown>
  try { d = await r.json() } catch { throw new ApiFout('De server gaf een onverwacht antwoord.', r.status, 'fout') }
  if (!r.ok || d.ok === false) {
    throw new ApiFout(typeof d.fout === 'string' ? d.fout : 'Er ging iets mis.', r.status, typeof d.code === 'string' ? d.code : 'fout')
  }
  return d as T
}

export const foutTekst = (e: unknown) => (e instanceof Error ? e.message : 'Er ging iets mis.')
